import urlPrefixes from '../../constants/urlPrefixes';
import { defaults as specialAttributesDefaults } from '../../constants/nonStandarts';
import { maxSeoAttributes } from '../../constants/standarts';

type TAttributeParams = {
  attributeValueKey: string;
  attributeValueId: number | string;
};

type TSeoFriendlyAttributes = {
  attributeValueLabel: string;
  attributeValueId: number | string;
};

type TObjectReturnParams = {
  seoFriendlyAttributes: TSeoFriendlyAttributes[];
  hashFriendlyAttributes: {};
};

export default (attributes: any, attributesOrder: string[] = []): TObjectReturnParams => {
  const seoFriendlyAttributes: any[] = [];
  const hashFriendlyAttributes: any = {};

  const pushValueKey = (attributeKey: string, attributeValue: TAttributeParams) => {
    if (hashFriendlyAttributes[attributeKey]) {
      hashFriendlyAttributes[attributeKey].push(encodeURIComponent(attributeValue.attributeValueKey));
    } else {
      hashFriendlyAttributes[attributeKey] = [encodeURIComponent(attributeValue.attributeValueKey)];
    }
  };

  const pushValueId = (attributeValue: TAttributeParams) => {
    const attributeKey = urlPrefixes.attributes;
    if (hashFriendlyAttributes[attributeKey]) {
      hashFriendlyAttributes[attributeKey].push(attributeValue.attributeValueId);
    } else {
      hashFriendlyAttributes[attributeKey] = [attributeValue.attributeValueId];
    }
  };

  const seoFriendlyKeys = Object.keys(attributes).map((key) => attributesOrder.indexOf(key) > -1 && key);

  // this is the part we apply all seo rules to seperate seo friendly and hash friendly attributes
  // more details : https://github.mpi-internal.com/bnl/vostok-adr/blob/master/adr-033-seo.md
  Object.keys(attributes)
    .sort((a, b) => attributesOrder.indexOf(a) - attributesOrder.indexOf(b))
    .filter((key) => attributes[key].length)
    .forEach((key) => {
      if (seoFriendlyKeys.indexOf(key) > -1 && Object.keys(seoFriendlyAttributes).length < maxSeoAttributes) {
        seoFriendlyAttributes.push(attributes[key][0]);
        attributes[key].slice(1, attributes[key].length).forEach(pushValueId);
      } else if (attributes[key][0].attributeValueId) {
        attributes[key].forEach(pushValueId);
      } else if (specialAttributesDefaults.attributes.indexOf(attributes[key][0].attributeValueKey) === -1) {
        attributes[key].forEach((value: TAttributeParams) => pushValueKey(key, value));
      }
    });

  return {
    seoFriendlyAttributes,
    hashFriendlyAttributes,
  };
};
